import { ColumnDef } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { formatPhone } from 'src/utils/format-phone';
import { RouterOutput } from 'src/trpc';
import { StatusDisplay } from 'src/components/StatusDisplay';

export const DriverColumns: ColumnDef<
  RouterOutput['admin']['driver']['getAllDrivers']['drivers'][0]
>[] = [
  {
    accessorKey: 'friendlyId',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Driver ID
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div className="w-fit">
          <span className="underline">{row.getValue('friendlyId')}</span>
        </div>
      );
    },
  },
  {
    accessorKey: 'name',
    accessorFn: (row) => `${row.name.first || ''} ${row.name.last || ''}`,
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
  },
  {
    accessorKey: 'email',
    header: 'Email',
  },
  {
    accessorKey: 'phone',
    header: 'Phone Number',
    accessorFn: (row) => formatPhone(row.phone || ''),
  },
  {
    accessorKey: 'status',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Status
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ row }) => (
      <div className="w-fit">
        <StatusDisplay status={row.getValue('status')} />
      </div>
    ),
  },
];
